export type CallRecordingStatus = 'EXPECTED' | 'RECORDING' | 'AVAILABLE' | 'FAILED' | 'DELETE_PENDING' | 'DELETED';

export type CallRecordingPresentation =
  | { kind: 'PLAYER'; label: string; url: string }
  | { kind: 'PENDING' | 'FAILED' | 'EMPTY' | 'DENIED' | 'DELETING' | 'DELETED'; label: string };

export function callRecordingPresentation(call: {
  recording_access?: 'ALLOWED' | 'DENIED' | null;
  recording_status?: CallRecordingStatus | null;
  recording_url?: string | null;
  recording_is_important?: boolean;
}): CallRecordingPresentation {
  if (call.recording_access === 'DENIED') {
    return { kind: 'DENIED', label: 'Нет доступа к записи' };
  }
  if (call.recording_status === 'AVAILABLE' && call.recording_url) {
    return { kind: 'PLAYER', label: 'Запись разговора', url: call.recording_url };
  }
  if (call.recording_status === 'DELETE_PENDING') {
    return { kind: 'DELETING', label: 'Удаляется по политике хранения' };
  }
  if (call.recording_status === 'DELETED') {
    return { kind: 'DELETED', label: 'Удалена по политике хранения' };
  }
  if (call.recording_status === 'EXPECTED' || call.recording_status === 'RECORDING') {
    return { kind: 'PENDING', label: 'Запись готовится' };
  }
  if (call.recording_status === 'FAILED' || call.recording_status === 'AVAILABLE') {
    return { kind: 'FAILED', label: 'Запись недоступна' };
  }
  return { kind: 'EMPTY', label: 'Нет записи' };
}
